import SessionTelemetry from '../store/schema/SessionTelemetry';

export default function updateTelemetryForSessionWithSessionDetails(
    sessionTelemetry: SessionTelemetry,
    modelVersion: string,
    sessionId: string
) {
    sessionTelemetry.modelVersion = modelVersion;
    if (sessionId) {
        sessionTelemetry.sessionId = sessionId;
    }
}
